import { Table } from "../../features/Table";
import { type OpenFigi, open_figis_columns } from "./columns";
import { FilterOpenFigis } from "./filter";

const client = "instit-quantilia";
const table_name = "open_figis";

export const OpenFigisTable = () => {
  return (
    <Table<OpenFigi, OpenFigi>
      label="Open Figis"
      client={client}
      table_name={table_name}
      columns={open_figis_columns}
      disable_translations_request={true}
      filter={<FilterOpenFigis />}
      actions={[]}
    />
  );
};
